import { useQuery, QueryObserverBaseResult } from "react-query"
import { queryKeys } from "../query"
import api from "../client"
import { GetUsedAddressResponseData } from "../types/address"

const getData = async () => {
  const { data } = await api.get(`/address/used`)
  return data
}

export const useUsedAddress = (): QueryObserverBaseResult<GetUsedAddressResponseData> => {
  const { data, ...props } = useQuery<GetUsedAddressResponseData>(
    queryKeys.ADDRESS_USED(),
    () => getData(),
  )
  return { data, ...props }
}
